import type { FC } from 'react';
import { EditAccount } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { Guard, usePermissionGuard } from 'features/login';

const EditAccountPage: FC = () => {
  const { accessToChangeFacebookadaccount } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToChangeFacebookadaccount}>
      <CabinetTitlePage
        title={'Accounts'}
        goBack={'/cabinet/facebook/accounts'}
      />
      <EditAccount />
    </Guard>
  );
};

export default EditAccountPage;
